const langPackLocalVersion = 62;export default langPackLocalVersion;
